import React from 'reactn'
import { useLocation, Navigate } from 'react-router-dom'

const NotFound = () => {
  const location = useLocation()

  if (location.pathname.startsWith('/medical')) {
    return <Navigate replace to="/medical" />
  } else {
    return <Navigate replace to="/" />
  }
}

export default NotFound
